import { dataContextGeneration } from "./dataContext";

/**
 * Dateien, die auf der Übersicht abgelegt wurden, gehen an „Belege hochladen“
 * weiter (#630). Nur im Speicher dieser Sitzung; nach einem Neuladen ist die
 * Auswahl weg, hochgeladen wird erst auf der Upload-Seite.
 *
 * Die Übergabe gehört dem bestätigten Benutzer-/Mandantenkontext, in dem sie
 * entstand: Nach einem Kontextwechsel oder einer Abmeldung wird sie verworfen,
 * nie in einen anderen Kontext übernommen.
 */
let handedOff: { context: number; files: File[] } | null = null;

export function handOffUploadFiles(files: File[]): boolean {
  const context = dataContextGeneration();
  handedOff = context === null || !files.length ? null : { context, files };
  return handedOff !== null;
}

export function takeHandedOffUploadFiles(): File[] {
  const pending = handedOff;
  handedOff = null;
  if (!pending || pending.context !== dataContextGeneration()) return [];
  return pending.files;
}
